import OrderList from './OrderList'
import agOrderList from './agOrderList'

export default [
  {
    path: '/null',
    component: () => import('@/components'),
    children: [
      ...OrderList,
      ...agOrderList
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/orderManage/index.js